import { useContext, useState } from 'react';
import { Avatar, AppModal, IconButton } from '../';
import { AppContext } from '../../providers/AppContext';
import { StyledTransferModal } from './TransferModal.styled';
import {
  OgHolder,
  OgInfo,
  OgInfoRow,
  OgInfoLabel,
  OgInfoValue,
  OgSelector
} from "../MintActionFigures/Modal/MintModalPhaseTwo.styled"
import MintModalHeader from '../MintActionFigures/Modal/MintModalHeader';
import { useWalletClient } from 'wagmi';

const ModalContent = ({ children }) => {
  return (
    <div className='transfer-modal-content'>
      {children}
    </div>
  );
};

const AssetTransfer = ({ asset, selectedFigure = null }) => {
  const [buttonTitle, setButtonTitle] = useState('Transfer');

  const { selectedBroadsider, wagmiConfig, setTransferAsset, inventoryItems, setInventoryItems, setErrorData } = useContext(AppContext);
  const [inProgress, setInProgress] = useState(false);
  const { data: walletClient } = useWalletClient();

  const onClick = async () => {
    try {
      setInProgress(true);
      await selectedBroadsider.sendAssetTo(asset.getId(), selectedFigure, walletClient, wagmiConfig, (title) => setButtonTitle(title));
      setInventoryItems(inventoryItems.filter(i => i.getId() !== asset.getId()));
      setErrorData({ title: 'Success', description: 'Transfer complete!', isError: false });
    } catch (err) {
      setErrorData({ title: 'Error', description: err.message });
    } finally {
      setTransferAsset(null);
      setInProgress(false);
      setButtonTitle('Transfer')
    }
  };

  return (
    <div>
    <div className='transfer-panel'>
      <div className='transfer-asset-image-holder'>
        <img className='transfer-asset-image-holder-bg' src='/assets/item_bg.png' />
        <img src={asset.getImgSource()} />
      </div>
      <div className='transfer-asset-title'>
        {asset.getName()}
      </div>
      <div className='transfer-asset-note'>
        <img src='/assets/info.svg' />
        <div>
          In order to transfer items between ACTION figures you have to create a Tokenbound Account (TBA) for sender figure.
        </div>
      </div>
      </div>
      <div className='transfer-button-holder'>
        <IconButton
          backgroundOverwrite='rgba(117, 225, 255, 1)'
          borderOverwriteHover='black'
          animated={true}
          disabled={inProgress || !selectedFigure}
          onClick={onClick}>
          <div className='transfer-button-content'>
            <img style={{paddingBottom: '6px'}} src='/assets/try_left.svg'/>
            <div>{buttonTitle}</div>
            <img style={{paddingBottom: '6px'}} src='/assets/try_right.svg'/>
          </div>
        </IconButton>
      </div>
    </div>
  );
}

const TransferModal = ({ asset }) => {
  const { selectedBroadsider, ownedBroadsiders } = useContext(AppContext);
  const [ogs, setOgs] = useState(ownedBroadsiders.filter(o => o.isReal() && o.getId() !== selectedBroadsider.getId()).map(b => ({ model: b, selected: false })));

  const onSelect = (index) => {
    const newOgs = ogs.map(o => ({...o, selected: false}));
    newOgs[index].selected = true;
    setOgs(newOgs);
  };
  const selectedFigure = ogs.find(o => o.selected);
  return (
    <AppModal>
      <MintModalHeader title='Transfer item'/>
      <StyledTransferModal>
        <ModalContent>
        <AssetTransfer asset={asset} selectedFigure={selectedFigure?.model}/>
        <div className='transfer-list-holder'>
        <OgSelector>
          {ogs.map((f, index) => (
            <OgHolder onClick={() => onSelect(index)} key={`og-${index}-${f.model.name}`}>
              <Avatar 
                key={'selec' + index} 
                figure={f.model} 
                isSelected={ogs[index].selected}
                isHovered={false}
              />
              <OgInfo>
                <OgInfoRow>
                  <OgInfoLabel>OG </OgInfoLabel>
                  <OgInfoValue $selected={!!ogs[index].selected}>{f.model.getName()}</OgInfoValue>
                </OgInfoRow>
                <OgInfoRow>
                  <OgInfoLabel># </OgInfoLabel>
                  <OgInfoValue $selected={!!ogs[index].selected}>{f.model.getId()}</OgInfoValue>
                </OgInfoRow>
              </OgInfo> 
            </OgHolder>
          ))}
        </OgSelector>
        <div className='selector-corner selector-corner-tl' />
        <div className='selector-corner selector-corner-tr' />
        <div className='selector-corner selector-corner-bl' />
        <div className='selector-corner selector-corner-br' />
        </div>
        </ModalContent>
      </StyledTransferModal>
    </AppModal>
  );
};

export default TransferModal;
